import { JetView } from 'webix-jet';
import { countries, devConfig, profile } from 'config/config';

/**
 * Class representing the FilterBalanceHistoryView.
 * @extends JetView
 */
export default class FilterBalanceHistoryView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text',
                            name: 'UserId',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // User ID label
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'), // Placeholder text
                        },
                        {
                            view: 'text',
                            minWidth: 200,
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'), // Creation date label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'), // Creation date label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        {
                            view: 'text',
                            name: 'UserIdAgent',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Concesionario'), // Dealer ID label
                            labelPosition: 'top',
                            placeholder: _('ID Concesionario'), // Placeholder text
                            hidden: !devConfig.getPermAction('filterByAgent', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByAgent',
                        },
                        {
                            view: 'text',
                            name: 'UserIdAgent2',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('Subconcesionario'), // Sub-dealer ID label
                            labelPosition: 'top',
                            placeholder: _('Subconcesionario'), // Placeholder text
                            hidden: !devConfig.getPermAction('filterByAgent2', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByAgent2',
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Country label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Country option template
                                        );
                                    },
                                    data: countries, // Country data source
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByCountry',
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    height: screen.width < 500 || screen.height < 500 ? 90 : 0, // Responsive height
                    cols: [
                        {
                            view: 'radio',
                            name: 'Type',
                            id: 'Type',
                            label: _('Tipo'), // Type label
                            labelPosition: 'top',
                            minWidth: 200,
                            value: 1, // Default radio value
                            options: [
                                { id: 1, value: _('Totales') }, // Total option
                                { id: 0, value: _('Detallado') }, // Detailed option
                            ],
                        },
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button label
                    width: 100,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Clear form values
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button label
                    hotkey: 'enter', // Shortcut key
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    minWidth: 200,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country if report is enabled
                        }
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('balanceHistory:filter', [
                            filterdata, // Trigger filter event with form data
                        ]);
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button label
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Clear form values
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button label
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country if report is enabled
                        }
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('balanceHistory:filter', [
                            filterdata, // Trigger filter event with form data
                        ]);
                        $$('filterPopup').hide(); // Hide the filter popup
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Accordion header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section with filters and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Scrollable section with upper filters
            },
        };
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Popup header
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close popup on icon click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Form with accordion and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 }, // Placeholder for small screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date field if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date field if typeDate is 2
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
